// react and mui stuff
import { useContext, useState } from "react";
import { UserContext } from "../../utils/contexts";
import { ToastContext } from "../toast";

import Autocomplete from "@mui/joy/Autocomplete"
import Button from "@mui/joy/Button"
import FormControl from "@mui/joy/FormControl"
import FormLabel from "@mui/joy/FormLabel"
import Option from "@mui/joy/Option"
import Select from "@mui/joy/Select"

// custom component
import PurposeHelper from "./purposeHelper";

// data and stuff
import { userAPI } from "../../utils/backend";
import { setData } from "../../utils/setdata";
import { CliUser } from "../../types/users";
import { updateUser } from "../../utils/utils";


export default function Roles () {
  const { user, setUser } = useContext(UserContext)
  const [opt, setOpt] = useState(getDefaultOpt(user?.roles))
  const [equip, setEquip] = useState(getDefaultEquip(user?.roles))
  const [updating, setUpdating] = useState(false);
  const { setToast } = useContext(ToastContext)

  // v useful
  function getDefaultOpt(roles?: CliUser["roles"] | null) {
    return roles?.optRoles.filter(r => r.on).map(r => ({ name: r.name, id: r.id })) ?? []
  }

  function getDefaultEquip(roles?: CliUser["roles"] | null) {
    return roles?.equipRoles.find(r => r.on) ?? null
  }

  // not logged in?
  if (!user) return <div/>

  return (
    <div style={{ display: "inline-block", width: "100%" }}>
      <PurposeHelper helpText="Opt in to pings and select a color to wear in the server."/>
      <form
        style={{ width: "100%" }}
        onSubmit={async (event) => {
          event.preventDefault();
          setUpdating(true)
          
          const optRoles = opt.map(o => o.id);
          
          userAPI.updateRoles(optRoles, equip?.id ?? "").then(info => {
            if (!setData(info, setToast, user, setUser, () => setUpdating(false))) return;

            setUser(updateUser(user, info))
            setEquip(getDefaultEquip(info.roles))
            setOpt(getDefaultOpt(info.roles))

            setToast({ text: "Roles updated!", color: "success" })
            setUpdating(false); 
          })
        }}
      >
        <FormControl sx={{ width: "100%" }}>
          <FormLabel>Opt-In Roles</FormLabel>
          <Autocomplete
            multiple
            name="optRoles"
            disableCloseOnSelect
            sx={{ width: "1000px", maxWidth: "90%" }}
            limitTags={5}
            placeholder="Select some roles"
            disableClearable
            options={user.roles.optRoles.map(o => ({ name: o.name, id: o.id }))}
            getOptionLabel={(opt) => opt.name}
            getOptionKey={(opt) => opt.id}
            isOptionEqualToValue={(opt, val) => opt.id === val.id}
            value={opt}
            onChange={(e, v) => setOpt(v)}
            disabled={updating}
          />
        </FormControl>
        <br/>
        <FormControl>
          <FormLabel>Equip Color Role</FormLabel>
          <Select
            name="equipRole"
            sx={{ maxWidth: "500px", width: "90%", color: equip?.color }}
            disabled={updating}
            value={equip}
            required
            onChange={(e, v) => setEquip(v)}>
            {user.roles.equipRoles.map(r =>
              <Option
                value={r}
                key={r.id}
                sx={{ color: r.color }}
              >
              {r.name}
              </Option>
            )}
          </Select>
        </FormControl>
        <br/>
        <Button type="submit" loading={updating}>Update</Button>
        <Button type="reset" onClick={() => {
          // set values back to default
          setOpt(getDefaultOpt())
          setEquip(getDefaultEquip())
        }
        } disabled={updating} size="sm" color="warning" variant="outlined" sx={{ marginLeft: "5px"}}>Reset</Button>
      </form>
    </div>
  )
}